import * as React from 'react';
import LogoutButton from '../LogoutButton';
import logo from '../../assets/ninja-logo.png';
import { Link, useLocation } from 'react-router-dom';
import './index.css';
import { useEffect, useState } from 'react';

const Header = ({ isAuthorised, showHeader = false }) => {
  const [displayHeader, toggleHeader] = useState(false);
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === '/') {
      toggleHeader(true);
    } else {
      toggleHeader(false);
    }
  }, [location]);
  return location.pathname === '/' || displayHeader || showHeader ? (
    <header>
      <nav className='border-bottom box-shadow flex items-center p-2 border'>
        <div className={`flex-row ml-auto container items-center flex ${isAuthorised ? 'agnet_authorized' : 'agnet_unauthorized'}`}>
          <img style={{ height: '30px', width: '30px' }} src={logo} />
          <Link className='font-normal text-center text-black break-all whitespace-normal' to='/'>
            AgNet
          </Link>
        </div>
        {isAuthorised && <LogoutButton />}
      </nav>
    </header>
  ) : null;
};

export default Header;
